import React, { useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { FaCheckCircle, FaExclamationCircle } from "react-icons/fa";
import "../../styles.css";

const AddToCartAlert = ({ show, handleClose, message }) => {
  const AlertIcon = message.includes("successfully") ? FaCheckCircle : FaExclamationCircle;
  const alertIconClass = message.includes("successfully") ? "alertIcon-check" : "alertIcon-exclaim";

  useEffect(() => {
    if (show) {
      const timer = setTimeout(() => {
        handleClose();
      }, 2000); // Close alert after 2 seconds
      return () => clearTimeout(timer); // Cleanup timeout on unmount or when `show` changes
    }
  }, [show, handleClose]);

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header className="alertCF-title">
        <Modal.Title>
          <AlertIcon className={alertIconClass} />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="alertCF-content">{message}</div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleClose} className="alertCF-button">
          OK
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddToCartAlert;
